import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DataStateChangeEvent, PagerPosition } from '@progress/kendo-angular-grid';
import { PagerType } from '@progress/kendo-angular-grid/dist/es2015/pager/pager-settings';
import { State } from '@progress/kendo-data-query';
import { UtilityService } from '../../../services/utils.service';
export interface IDataConfig{
  incompleteCount: number;
  maxItemsReached: boolean;
  total: number;
};
export interface IColumns<T = any>{
  title: string;
  field: string;
  isUrl?: boolean;
  isHidden?: boolean;
  multiselectUnavailable?: boolean;
  style?: (rowData: T) => string | string[] | Set<string> | { [klass: string]: any };
};
export interface IItemGrid{
  id: string;
  index: number;
};
@Component({
  selector: 'app-custom-grid',
  templateUrl: './custom-grid.component.html',
  styleUrls: ['./custom-grid.component.scss']
})
export class CustomGridComponent implements OnChanges, OnInit {
  public pagerTypes = ["numeric", "input"];
  public type: PagerType = "numeric";
  public buttonCount = 10;
  public info = true;
  public pageSizes = [1, 10, 20, 50, 100, 200];
  public previousNext = true;
  public position: PagerPosition = "bottom";
  dataViewCustom: any;
  public skip = 0;
  public state: State = {
    skip: 0,
    take: 10,
    group: [],
    filter: { filters: [], logic: "and" },
    sort: [],
  };
  @Input() dataView: any = [];
  @Input() columns: IColumns[];
  @Input() pageSize: number=1;
  @Input() total: number = 0;
  @Input() originalSite: string;
  @Input() gridConfig?: IDataConfig;
  @Output() onDeleteGridItem = new EventEmitter<IItemGrid>();
  @Output() onPaginate = new EventEmitter<DataStateChangeEvent>();
  @Output() onEditGridItem = new EventEmitter<any>();
  
  constructor(
    public _utilityService: UtilityService,
  ) { }
  ngOnInit(): void {
    this.state.take = this.pageSize;
  };
  ngOnChanges(changes: SimpleChanges): void{
    if(changes.originalSite)
      this.originalSite = changes.originalSite.currentValue;
    if(changes&&changes.pageSize){
      this.pageSize = changes.pageSize.currentValue;
    };
  };
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.onPaginate.emit(state)
    this.onPaginate.emit(state)
  };
  public loadItems(): void {
    this.dataView = {
      data: this.dataViewCustom, 
      total: this.total,
    };
  };
  deletItem(dataItem: any, i: number){
    this.onDeleteGridItem.emit({
      id: dataItem.id,
      index: i
    });
  };
  editItem(dataItem: any, i: number){
    this.onEditGridItem.emit({
      dataItem: dataItem,
      index: i
    });
  };

  getItem(dataItem: any, i: number){
    return dataItem[this.columns[i].field];
  }
  getColumns(columns: IColumns[]){
    if(columns)
      return columns.filter(x=>!x.isHidden);
    return null;
  }
};
